import request from "~/utils/http";

const rolesApi = {
	gets : async (params) => {
		const url = 'role';
		return await request.get(url);
	},
	add : async (params) => {
		const url = 'role/add';
		return await request.post(url, params);
	},
	permissionByRole : async (params) => {
		const url = `role/${params}`;
		return await request.get(url);
	},
	permissionList : async (params) => {
		const url = 'role/permission';
		return await request.get(url);
	},
	permissionUpdate : async (params) => {
		const url = `role/permission/${params.role}`;
		return await request.put(url, params);
	},
};

export default rolesApi;